/* ============================================================
   Gear Guard Mega Menu — mega-menu.js
   Upload to: assets/mega-menu.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Desktop mega open / close ─────────────────────────── */
  const navItems = document.querySelectorAll('.gg-nav-item');
  const megas    = document.querySelectorAll('.gg-mega');

  function closeAll() {
    navItems.forEach(n => { n.classList.remove('gg-open'); n.setAttribute('aria-expanded', 'false'); });
    megas.forEach(m => m.classList.remove('gg-open'));
  }

  navItems.forEach(function (btn) {
    const targetId = btn.getAttribute('aria-controls');
    if (!targetId) return;
    const panel = document.getElementById(targetId);
    if (!panel) return;

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = btn.classList.contains('gg-open');
      closeAll();
      if (!isOpen) {
        btn.classList.add('gg-open');
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('gg-open');
      }
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
      if (e.key === 'Escape') closeAll();
    });
  });

  document.addEventListener('click', function (e) {
    const header = document.getElementById('ggHeader');
    if (header && !header.contains(e.target)) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ── Brand → model maps (exact match to car_manufacturer metaobject name.value) ── */
  const modelsByBrand = {
    'Hyundai':             ['i10', 'i20', 'Creta', 'Venue', 'Alcazar', 'Exter', 'Tucson'],
    'Maruti Suzuki':       ['Baleno', 'Fronx', 'Brezza', 'Ertiga', 'Swift', 'WagonR', 'Grand Vitara', 'Dzire', 'S-Cross', 'Invicto'],
    'TATA':                ['Nexon', 'Nexon EV', 'Punch', 'Punch EV', 'Harrier', 'Safari', 'Curvv', 'Curvv EV', 'Altroz', 'Tiago', 'Tiago EV', 'Tigor', 'Sierra'],
    'Kia':                 ['Seltos', 'Sonet', 'Carens', 'Clavis', 'EV6', 'EV9'],
    'Mahindra':            ['XUV700', 'XUV 7XO', 'XUV3XO', 'Thar', 'Thar Roxx', 'Scorpio N', 'XEV 9E', 'XEV 9S', 'BE6'],
    'Honda':               ['City', 'Amaze', 'Elevate', 'WR-V'],
    'Toyota':              ['Fortuner', 'Innova Hycross', 'Innova Crysta', 'Glanza', 'Rumion', 'Urban Cruiser Taisor', 'Camry', 'Vellfire'],
    'MG':                  ['Hector', 'Windsor', 'Gloster', 'Astor', 'ZS EV', 'Comet EV'],
    'Volkswagen':          ['Virtus', 'Taigun', 'Polo'],
    'Skoda':               ['Slavia', 'Kushaq', 'Kylaq', 'Octavia', 'Rapid'],
    'BMW':                 ['X1', 'X3', 'X5', 'X7', '3 Series', '5 Series', 'iX', 'iX1', 'iX3', 'M3'],
    'Mercedes Benz':       ['C-Class', 'E-Class', 'A-Class', 'GLA', 'GLC', 'GLE', 'EQS', 'EQB'],
    'BYD':                 ['Seal', 'Sealion 6', 'Sealion 7', 'Atto 3'],
    'Jeep':                ['Compass', 'Meridian', 'Wrangler', 'Grand Cherokee'],
    'Vinfast':             ['VF6', 'VF7'],
    'Renault':             ['Kiger', 'Kwid', 'Triber'],
    'Nissan':              ['Magnite', 'Gravite', 'Kicks', 'X-Trail'],
    'Land Rover':          ['Defender', 'Discovery Sport', 'Range Rover Sport', 'Range Rover Velar', 'Autobiography'],
    'Audi':                ['Q3', 'Q5', 'Q7', 'Q8', 'A4', 'A6', 'e-tron', 'e-tron GT'],
    'Porsche':             ['Cayenne', 'Macan', 'Panamera', 'Taycan', '911'],
    'Volvo':               ['XC40', 'XC60', 'XC90', 'S60', 'S90', 'EX30', 'EX90'],
    'Tesla':               ['Model 3', 'Model Y', 'Model S', 'Model X'],
    'JSW':                 ['Windsor EV', 'Comet EV'],
    'Ford':                ['EcoSport', 'Endeavour', 'Freestyle', 'Aspire'],
    'Citroen':             ['C3', 'C5 Aircross'],
    'Android Aftermarket': ['7 inch', '9 inch', '10 inch', '12 inch'],
  };

  const modelsByBike = {
    'Hero':              ['Splendor+', 'HF Deluxe', 'Passion Pro', 'Glamour', 'Super Splendor', 'Xtreme 160R', 'Xpulse 200'],
    'Honda Two Wheeler': ['Activa 6G', 'SP 125', 'Shine 100', 'CB Shine', 'Hornet 2.0', 'Unicorn', 'CB300R'],
    'Bajaj':             ['Pulsar 150', 'Pulsar N160', 'Pulsar NS200', 'Avenger Street 160', 'Dominar 400', 'CT110X', 'Platina 110'],
    'TVS':               ['Apache RTR 160', 'Apache RTR 200 4V', 'Jupiter 125', 'Ntorq 125', 'Raider 125', 'Sport'],
    'Yamaha':            ['FZ-S FI', 'FZ25', 'MT-15 V2', 'R15 V4', 'Fascino 125', 'Ray-ZR 125'],
    'Royal Enfield':     ['Classic 350', 'Meteor 350', 'Hunter 350', 'Bullet 350', 'Himalayan 450', 'Guerrilla 450'],
    'KTM':               ['Duke 200', 'Duke 250', 'Duke 390', 'RC 390', 'Adventure 250', 'Adventure 390'],
    'Suzuki':            ['Access 125', 'Burgman Street 125', 'Gixxer 150', 'Gixxer SF 150', 'Intruder 150'],
    'Kawasaki':          ['Ninja 300', 'Ninja 400', 'Z650', 'Versys 650', 'W175'],
    'Ola':               ['S1 Air', 'S1 X', 'S1 Pro'],
    'Ather':             ['450X', '450 Apex', 'Rizta'],
    'Aprilia':           ['SR 125', 'SR 160', 'SR 200', 'Storm 125'],
    'EV Scooter':        ['Generic 48V', 'Generic 60V', 'Generic 72V'],
  };

  /* ── Helper ─────────────────────────────────────────────── */
  function populateSelect(select, items) {
    select.innerHTML = '<option value="">' + select.getAttribute('aria-label') + '</option>';
    items.forEach(function (v) {
      var o = document.createElement('option');
      o.value = o.textContent = v;
      select.appendChild(o);
    });
  }

  function populateYears(select) {
    select.innerHTML = '<option value="">Year</option>';
    for (var y = new Date().getFullYear(); y >= 2018; y--) {
      var o = document.createElement('option');
      o.value = o.textContent = y;
      select.appendChild(o);
    }
  }

  function wireCarFinder(brandId, modelId, yearId, searchId, map) {
    var brand  = document.getElementById(brandId);
    var model  = document.getElementById(modelId);
    var year   = yearId  ? document.getElementById(yearId)  : null;
    var search = searchId ? document.getElementById(searchId) : null;
    if (!brand || !model) return;

    brand.addEventListener('change', function () {
      populateSelect(model, map[brand.value] || []);
      if (year) year.innerHTML = '<option value="">Year</option>';
    });
    if (year) {
      model.addEventListener('change', function () {
        if (model.value) populateYears(year);
        else year.innerHTML = '<option value="">Year</option>';
      });
    }
    if (search) {
      search.addEventListener('click', function () {
        var b = brand.value, m = model.value, y = year ? year.value : '';
        if (b && m) window.location.href = '/search?type=product&q=' + encodeURIComponent([y, b, m].filter(Boolean).join(' '));
      });
    }
  }

  function wireBikeFinder(brandId, modelId, searchId, map) {
    var brand  = document.getElementById(brandId);
    var model  = document.getElementById(modelId);
    var search = searchId ? document.getElementById(searchId) : null;
    if (!brand || !model) return;

    brand.addEventListener('change', function () {
      populateSelect(model, map[brand.value] || []);
    });
    if (search) {
      search.addEventListener('click', function () {
        var b = brand.value, m = model.value;
        if (b && m) window.location.href = '/search?type=product&q=' + encodeURIComponent([b, m].join(' '));
      });
    }
  }

  /* Desktop car */  wireCarFinder('fBrand',   'fModel',   'fYear',  'fSearch',   modelsByBrand);
  /* Mobile car */   wireCarFinder('mfBrand',  'mfModel',  'mfYear', 'mfSearch',  modelsByBrand);
  /* Desktop bike */ wireBikeFinder('bfBrand',  'bfModel',  'bfSearch',  modelsByBike);
  /* Mobile bike */  wireBikeFinder('mbfBrand', 'mbfModel', 'mbfSearch', modelsByBike);

  /* ── Desktop car scroll arrows ─────────────────────────── */
  var carScroll = document.getElementById('carScroll');
  var carLeft   = document.getElementById('carScrollLeft');
  var carRight  = document.getElementById('carScrollRight');
  if (carScroll && carLeft && carRight) {
    carLeft.addEventListener('click',  function () { carScroll.scrollBy({ left: -320, behavior: 'smooth' }); });
    carRight.addEventListener('click', function () { carScroll.scrollBy({ left:  320, behavior: 'smooth' }); });
  }

  /* ── Mobile drawer ──────────────────────────────────────── */
  var mobileToggle = document.getElementById('mobileMenuToggle');
  var mobileDrawer = document.getElementById('mobileDrawer');
  if (mobileDrawer && mobileDrawer.parentElement !== document.body) document.body.appendChild(mobileDrawer);

  var overlay = null;
  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'gg-drawer-overlay';
      overlay.addEventListener('click', closeDrawer);
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function openDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.removeAttribute('hidden');
    mobileDrawer.getBoundingClientRect(); // force reflow
    mobileDrawer.classList.add('gg-drawer-open');
    getOverlay().classList.add('gg-drawer-visible');
    mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('gg-drawer-open');
    if (overlay) overlay.classList.remove('gg-drawer-visible');
    mobileToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!mobileDrawer.classList.contains('gg-drawer-open')) {
        mobileDrawer.setAttribute('hidden', '');
        if (overlay) { overlay.parentNode && overlay.parentNode.removeChild(overlay); overlay = null; }
      }
    }, 300);
  }

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () {
      mobileDrawer.classList.contains('gg-drawer-open') ? closeDrawer() : openDrawer();
    });
  }
  var drawerClose = document.getElementById('drawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ── Mobile accordion (delegated — works after drawer moves to <body>) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.gg-mob-nav-item') : null;
    if (!btn) return;
    var panelId = btn.getAttribute('aria-controls');
    if (!panelId) return;
    var panel = document.getElementById(panelId);
    if (!panel) return;
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('.gg-mob-nav-item').forEach(function (other) {
      if (other !== btn) {
        other.setAttribute('aria-expanded', 'false');
        var id = other.getAttribute('aria-controls');
        if (id) { var p = document.getElementById(id); if (p) p.hidden = true; }
      }
    });
    btn.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });

  /* ── Cart count live update ─────────────────────────────── */
  document.addEventListener('cart:updated', function (e) {
    var count = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
    document.querySelectorAll('.gg-cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  });

})();
